module.exports = {
  generateHeaderMenuLinks(arr) {
    return arr.map((link) => `<a href="${link.href}">${link.label}</a>`).join('');
  },

  createElem(el, options, text) {
    const newElement = document.createElement(el);
  
    if (options !== undefined) {
      Object.keys(options).forEach((attr) => {
        newElement.setAttribute(attr, options[attr]);
      });
    }
  
    if (text !== undefined) {
      newElement.innerHTML = text;
    }
  
    return newElement;
  },
};



// WEBPACK FOOTER //
// ./scriptPartials/helperFunctions.js